<div class="bolide-loader-container">
    <video 
        id="bolide-loader-video" 
        autoplay 
        muted 
        loop 
        playsinline
    ></video>
</div>